import {
  GET_PROJECTS_FAIL,
  GET_PROJECTS_FETCHING,
  GET_PROJECTS_SUCCESS
} from '../actions/projectsActions';

const initialState = {
  projects: [],
  loading: false,
  errors: '',
  totalRecords: 0
};


const projects = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROJECTS_FETCHING:
      return { ...state, loading: true };
    case GET_PROJECTS_FAIL:
      return { ...state, loading: false, errors: action.payload.message };
    case GET_PROJECTS_SUCCESS:
      return { ...state, projects: action.payload.projects.projects, totalRecords: Number(action.payload.projects.total_records), loading: false, errors: '' };
    default:
      return state;
  }
};

export default projects;
